<section class="g-brd-bottom g-brd-gray-light-v4 g-py-30 breadcrumbs">
  <div class="container">
    <ul class="d-flex justify-content-between u-list-inline">
      <li class="list-inline-item g-mr-15">
        <a class="u-link-v5 g-color-text g-pr-10" routerLink="/">Home</a>
        <i class="g-color-gray-light-v2 g-ml-5 fa fa-angle-right"></i>
      </li>
      <li class="list-inline-item g-color-primary">
        <span>Board Members</span>
      </li>
      <li class="list-inline-item ml-auto">
        <a class="u-link-v5 g-brd-around g-brd-gray-light-v4 g-brd-primary--hover g-color-text g-color-primary--hover g-font-weight-500 rounded g-px-30 g-py-10"
          routerLink="/getquote">Get quote</a>
      </li>
    </ul>
  </div>
</section>

<div class="container g-pt-100 g-pb-70" style="margin-top: -50px">
  <div class="row">
    <div class="col-lg-9 g-mb-30">
      <div class="u-shadow-v1-5 g-line-height-2 g-pa-40 g-mb-30" role="alert">
        
        <!-- Add this simple header with reorder button -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <h3 class="mb-0">
            <strong>Board Members</strong>
          </h3>
          <button 
            style="background: #052c52; color: white; border: none; padding: 10px 15px; border-radius: 5px; cursor: pointer;"
            (click)="toggleReorderMode()">
            {{ isReorderMode ? 'Exit Reorder' : 'Reorder Board' }}
          </button>
        </div>

        <!-- Loading State -->
        <div *ngIf="preLoader" class="text-center">
          <p>Loading board members...</p>
        </div>

        <!-- No Data State -->
        <div *ngIf="noData && !preLoader" class="text-center">
          <p>No board members found.</p>
        </div>

        <!-- Board Members List -->
        <div class="alcenter" *ngIf="!preLoader && !noData">
          <div class="movdow" *ngFor="let board of Board; let i = index">
            
            <!-- Add position number and up/down buttons only when reordering -->
            <div *ngIf="isReorderMode" style="display: flex; flex-direction: column; gap: 5px; margin-right: 10px;">
              <span style="background: #052c52; color: white; width: 25px; height: 25px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px;">{{ i + 1 }}</span>
              <button 
                style="background: #052c52; color: white; border: none; width: 25px; height: 25px; border-radius: 3px; cursor: pointer; font-size: 12px;"
                (click)="moveUp(i)" 
                [disabled]="i === 0">↑</button>
              <button 
                style="background: #052c52; color: white; border: none; width: 25px; height: 25px; border-radius: 3px; cursor: pointer; font-size: 12px;"
                (click)="moveDown(i)" 
                [disabled]="i === Board.length - 1">↓</button>
            </div>

            <div class="image">
              <img src="{{board.image}}" alt="{{board.name}}">
            </div>
            
            <div class="details">
              <p class="mname">{{board.name}}</p>
              <p class="mtitle">{{board.title}}</p>
            </div>
            
            <!-- Hide edit/delete buttons during reorder -->
            <div class="buts" *ngIf="!isReorderMode">
              <a id="edit" [routerLink]="['/edit-board/', board.$key]">Edit</a>
              <a id="delete" (click)="deletee(board)">Delete</a>
            </div>
          </div>
        </div>

        <br /><br />
        <div class="butnn" *ngIf="!isReorderMode">
          <a routerLink="/add-board" id="create">Create</a>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div class="col-lg-3 g-mb-30">
      <app-sidebar></app-sidebar>
    </div>
  </div>
</div>